import classNames from 'classnames';
import { useState } from 'react';
import MediaQuery from 'react-responsive';
import { t } from 'ttag';

import AlreadyComplain from '@components/AlreadyComplain';
import { MEDIUM } from '@ui/mq';
import MessageWarningIcon from '@svg/message-warning.svg';

// styles
import s from './CanComplain.sss';

// types
type CanComplainProps = {
  className?: string;
  canComplain: boolean;
  allowComplain: (allow: boolean) => void;
  userId: number;
  setUserId: (userId: number) => void;
  username: string;
  productPage: boolean;
};

export const CanComplain: React.FC<CanComplainProps> = ({
  className,
  canComplain,
  allowComplain,
  setUserId,
  userId,
  username,
  productPage,
}) => {
  const [complainedModal, openComplainedModal] = useState(false);
  const closeComplaint = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    openComplainedModal(false);
  };
  const openComplaint = () => openComplainedModal(true);

  const openComplain = (
  ) => {
    setUserId(userId);
    allowComplain(true);
  };
  return canComplain
    ? (
      <>
        <MediaQuery maxWidth={MEDIUM}>
          <a
            className={classNames(s.root, className, productPage ? '' : s.mobile)}
            onClick={openComplain}
          >
            <MessageWarningIcon className={s.icon} />
            <span className={s.text}>{t`Повідомити про порушення`}</span>
          </a>
        </MediaQuery>
        <MediaQuery minWidth={MEDIUM + 1}>
          <a
            className={classNames(s.root, className)}
            onClick={openComplain}
          >
            <MessageWarningIcon className={s.icon} />
            <span className={s.text}>{t`Повідомити про порушення`}</span>
          </a>
        </MediaQuery>
      </>
    )
    : (
      <>
        <MediaQuery maxWidth={MEDIUM}>
          <a
            className={classNames(s.root, className)}
            onClick={openComplaint}
          >
            <MessageWarningIcon className={s.icon} />
            <span className={s.text}>{t`Повідомити про порушення`}</span>
            <AlreadyComplain
              isOpen={complainedModal}
              onClose={closeComplaint}
              username={username}
            />
          </a>
        </MediaQuery>
        <MediaQuery minWidth={MEDIUM + 1}>
          <a
            className={classNames(s.root, className)}
            onClick={openComplaint}
          >
            <MessageWarningIcon className={s.icon} />
            <span className={s.text}>{t`Повідомити про порушення`}</span>
            <AlreadyComplain
              isOpen={complainedModal}
              onClose={closeComplaint}
              username={username}
            />
          </a>
        </MediaQuery>
      </>
    );
};

export default CanComplain;
